var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5921 8.69263C10.5921 9.7972 9.69669 10.6926 8.59212 10.6926C7.48755 10.6926 6.59212 9.7972 6.59212 8.69263C6.59212 7.58806 7.48755 6.69263 8.59212 6.69263C9.69669 6.69263 10.5921 7.58806 10.5921 8.69263Z",
    stroke: "#9DA3AE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23096 8.69261C3.08047 5.98788 5.60733 4.02596 8.59241 4.02596C11.5775 4.02596 14.1044 5.98791 14.9539 8.69265C14.1044 11.3974 11.5775 13.3593 8.59243 13.3593C5.60733 13.3593 3.08046 11.3974 2.23096 8.69261Z",
    stroke: "#9DA3AE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.e116cece3c9fab348e2b238d4748bee0.svg";
export { ForwardRef as ReactComponent };